/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class GroupsRoute extends Route {
  queryParams = {
    year: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  @tracked
  lastPersonId = '';

  model(params) {
    let person = this.modelFor('people.person').person;
    let year = moment().year();
    let idKey = 'staffId';

    // Allow years from 2000 up to next year (so that next year's groups can be seen / worked with).
    if (!isEmpty(params.year)) {
      let yearParam = parseInt(params.year, 10);
      if (yearParam >= 2000 && yearParam <= year + 1) {
        year = yearParam;
      }
    }

    switch (person.type) {
      case PersonType.LEARNER:
        idKey = 'learnerId';
        break;
      case PersonType.CAREGIVER:
        idKey = 'caregiverId';
        break;
    }

    return hash({
      person,
      groups: this.store.query('group', { [idKey]: person.id, year }),
    });
  }

  beforeModel() {
    super.beforeModel(...arguments);

    // Reset "year" parameter if the person ID has changed (i.e. user has navigated to a different person's groups page)
    let personId = this.paramsFor('people.person').person_id;
    if (this.lastPersonId !== personId) {
      if (this.controller) {
        this.controller.set('year', moment().year());
      }
      this.lastPersonId = personId;
    }
  }
}
